import type { FluxErrorEntityErrorCodes } from '../types.js';

export const UploadErrorCodes = {
  UploadOnlyImage: {
    code: 'upload/only-image',
    message: 'Apenas arquivos de imagem são permitidos neste campo.',
    explanation: 'Apenas arquivos de imagem são permitidos para este upload, imagens aceitas incluem: JPG, JPEG, PNG.',
    localizations: {},
  },
} as const satisfies FluxErrorEntityErrorCodes<'upload'>;
